module.exports = __webpack_public_path__ + "static/roboto-regular-d6b71d6e9347a04cf8d282996a7eb318.woff";